import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-grey text-white">
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
                    {/* About Section */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">About TechCognita</h3>
                        <p className="text-grey-400">
                            Bridging the gap between education, technology, and industry demands through quality training programs and IT services.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/courses" className="text-grey-400 hover:text-white">
                                    Courses
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className="text-grey-400 hover:text-white">
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link to="/projects" className="text-grey-400 hover:text-white">
                                    Projects
                                </Link>
                            </li>
                            <li>
                                <Link to="/careers" className="text-grey-400 hover:text-white">
                                    Careers
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-grey-400 hover:text-white">
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Our Services</h3>
                        <ul className="space-y-2">
                            <li className="text-grey-400">Web Development</li>
                            <li className="text-grey-400">Mobile App Development</li>
                            <li className="text-grey-400">AI Solutions</li>
                            <li className="text-grey-400">Cloud Services</li>
                        </ul>
                    </div>

                    {/* Legal Links */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Legal</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/legal/terms-and-conditions" className="text-grey-400 hover:text-white">
                                    Terms & Conditions
                                </Link>
                            </li>
                            <li>
                                <Link to="/legal/privacy-policy" className="text-grey-400 hover:text-white">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/legal/refund-policy" className="text-grey-400 hover:text-white">
                                    Refund Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/legal/disclaimer" className="text-grey-400 hover:text-white">
                                    Disclaimer
                                </Link>
                            </li>
                            <li>
                                <Link to="/legal/delivery-policy" className="text-grey-400 hover:text-white">
                                    Delivery Policy
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
                        <ul className="space-y-2">
                            <li className="text-grey-400">
                                <span className="font-medium">Email:</span> founder@techcognita.com
                            </li>
                            <li className="text-grey-400">
                                <span className="font-medium">Phone:</span> +91 7558508876
                            </li>
                            <li className="text-grey-400">
                                <span className="font-medium">Address:</span> Room No-1 Shinde Cottage, Kali Mata Mandir Opp, Bhandup, Mumbai, 400078, India
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Social Links */}
                <div className="mt-8 pt-8 border-t border-grey-800">
                    <div className="flex justify-center space-x-6">
                        <a
                            href="https://facebook.com/techcognita"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-grey-400 hover:text-white"
                        >
                            <span className="sr-only">Facebook</span>
                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                            </svg>
                        </a>
                        <a
                            href="https://twitter.com/techcognita"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-grey-400 hover:text-white"
                        >
                            <span className="sr-only">Twitter</span>
                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                            </svg>
                        </a>
                        <a
                            href="https://linkedin.com/company/techcognita"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-grey-400 hover:text-white"
                        >
                            <span className="sr-only">LinkedIn</span>
                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-.88-.06-1.601-1-1.601-1 0-1.14.781-1.14 1.601v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                            </svg>
                        </a>
                    </div>
                </div>

                {/* Copyright */}
                <div className="mt-8 text-center text-grey-400">
                    <p>&copy; {new Date().getFullYear()} TechCognita. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;